<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-md-3">
        <SearchFilters
          :sex-options="sexOptions"
          :age-min="ageMin"
          :age-max="ageMax"
          :color-options="colorOptions"
          :pattern-options="patternOptions"
          :height-min="heightMin"
          :height-max="heightMax"
          :price-min="priceMin"
          :price-max="priceMax"
          :registry-options="registryOptions"
          v-model:keyword-filter="keywordFilter"
          v-model:sex-filter="sexFilter"
          v-model:age-filter-min="ageFilterMin"
          v-model:age-filter-max="ageFilterMax"
          v-model:color-filter="colorFilter"
          v-model:pattern-filter="patternFilter"
          v-model:height-filter-min="heightFilterMin"
          v-model:height-filter-max="heightFilterMax"
          v-model:price-filter-min="priceFilterMin"
          v-model:price-filter-max="priceFilterMax"
          v-model:registry-filter="registryFilter"
        />
      </div>
      <div class="col-xs-12 col-md-9">
        <SearchResults
          :horses="horses"
          @load-more="loadMore"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* global currentPageId, horses, numberPerPage, sexOptions, colorOptions, patternOptions, registryOptions, selectedSex */

import SearchFilters from './components/SearchFilters.vue'
import SearchResults from './components/SearchResults.vue'

export default {
  name: 'HorseSearch',
  components: {
    SearchFilters,
    SearchResults
  },
  data () {
    return {
      currentPageId: currentPageId,
      allHorses: horses,
      allSexOptions: sexOptions,
      allColorOptions: colorOptions,
      allPatternOptions: patternOptions,
      allRegistryOptions: registryOptions,
      horses: [],
      sexOptions: [],
      ageMin: 0,
      ageMax: 50,
      colorOptions: [],
      patternOptions: [],
      heightMin: 0,
      heightMax: 40,
      priceMin: 0,
      priceMax: 999999,
      registryOptions: [],
      keywordFilter: '',
      sexFilter: '',
      ageFilterMin: 0,
      ageFilterMax: 50,
      colorFilter: [],
      patternFilter: [],
      heightFilterMin: 0,
      heightFilterMax: 40,
      priceFilterMin: 0,
      priceFilterMax: 999999,
      registryFilter: false,
      maxToShow: 10,
      numberPerPage: numberPerPage,
      currentlyShowing: 0,
      blockSelectedSex: selectedSex,
      useLocalStorage: false,
      loadingComplete: false
    }
  },
  created: function () {
    if (typeof localStorage !== 'undefined') {
      this.useLocalStorage = true
    }

    var urlParams = [];
    (window.onpopstate = function () {
      var match
      var pl = /\+/g // Regex for replacing addition symbol with a space
      var search = /([^&=]+)=?([^&]*)/g
      var decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')) }
      var query = window.location.search.substring(1)

      var filters = ['sex', 'color', 'pattern', 'registry']

      while ((match = search.exec(query))) {
        if (filters.indexOf(decode(match[1])) >= 0) {
          urlParams.push({ name: decode(match[1]), value: decodeURIComponent(match[2]) })
        }
      }
    })()

    // if we have urlParams load the data from those, otherwise load from local storage if we have it
    if (urlParams.length) {
      this.sexFilter = []
      this.colorFilter = []
      this.patternFilter = []
      this.registryFilter = []

      urlParams.forEach(function (urlParam) {
        var paramValue = decodeURIComponent(urlParam.value.replace(/\+/g, ' '))
        if (paramValue.length) {
          switch (urlParam.name) {
            case 'sex':
              this.sexFilter.push(paramValue)
              break
            case 'color':
              this.colorFilter.push(paramValue)
              break
            case 'pattern':
              this.patternFilter.push(paramValue)
              break
            case 'registry':
              this.registryFilter.push(paramValue)
              break
          }
        }
      }, this)
    } else {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        this.sexFilter = (this.blockSelectedSex.length === 0 ? (localStorage.getItem('sexFilter__' + this.currentPageId) === null) ? [] : JSON.parse(localStorage.getItem('sexFilter__' + this.currentPageId)) : []) // do not set the sex filter if the sex was set in the block
        this.colorFilter = (localStorage.getItem('colorFilter__' + this.currentPageId) === null) ? [] : JSON.parse(localStorage.getItem('colorFilter__' + this.currentPageId))
        this.patternFilter = (localStorage.getItem('patternFilter__' + this.currentPageId) === null) ? [] : JSON.parse(localStorage.getItem('patternFilter__' + this.currentPageId))
        this.registryFilter = (localStorage.getItem('registryFilter__' + this.currentPageId) === null) ? [] : JSON.parse(localStorage.getItem('registryFilter__' + this.currentPageId))
      }
    }

    this.updateFilters()
    this.filterHorses()
    this.loadingComplete = true
  },
  watch: {
    keywordFilter: function () {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        localStorage.setItem('keywordFilter__' + this.currentPageId, JSON.stringify(this.keywordFilter))
      }
      if (this.loadingComplete) {
        this.maxToShow = this.numberPerPage
        this.updateFilters()
        this.filterHorses()
      }
    },
    sexFilter: function () {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        localStorage.setItem('sexFilter__' + this.currentPageId, JSON.stringify(this.sexFilter))
      }
      if (this.loadingComplete) {
        this.maxToShow = this.numberPerPage
        this.updateFilters()
        this.filterHorses()
      }
    },
    ageFilterMin: {
      handler: function () {
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      }
    },
    ageFilterMax: {
      handler: function () {
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      }
    },
    colorFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('colorFilter__' + this.currentPageId, JSON.stringify(this.colorFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      },
      deep: true
    },
    patternFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('patternFilter__' + this.currentPageId, JSON.stringify(this.patternFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      },
      deep: true
    },
    heightFilterMin: {
      handler: function () {
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      }
    },
    heightFilterMax: {
      handler: function () {
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      }
    },
    priceFilterMin: {
      handler: function () {
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      }
    },
    priceFilterMax: {
      handler: function () {
        if (this.loadingComplete) {
          this.maxToShow = this.numberPerPage
          this.filterHorses()
        }
      }
    },
    registryFilter: function () {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        localStorage.setItem('registryFilter__' + this.currentPageId, JSON.stringify(this.registryFilter))
      }
      if (this.loadingComplete) {
        this.maxToShow = this.numberPerPage
        this.filterHorses()
      }
    }
  },
  methods: {
    filterHorses: function () {
      this.currentlyShowing = 0
      this.horses = []

      for (let i = 0; i < this.allHorses.length; i++) {
        let hide = false
        this.currentlyShowing++
        const checkHorse = this.allHorses[i]

        if (!hide) {
          if (this.keywordFilter.length) {
            // if this horse matches the keywords
            const keywordMatched = checkHorse.name.toLowerCase().includes(this.keywordFilter.toLowerCase())
            if (!keywordMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.sexFilter.length) {
            // if this horse matches any of the selected sexes, show it
            let sexMatched = false
            for (let j = 0; j < this.sexFilter.length; j++) {
              const checkSex = this.sexFilter[j]
              if (checkSex === checkHorse.sex) {
                sexMatched = true
                break
              }
            }

            if (!sexMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          let ageMatched = true
          if (this.ageFilterMin > checkHorse.age || this.ageFilterMax < checkHorse.age) {
            ageMatched = false
          }

          if (!ageMatched) {
            hide = true
            this.currentlyShowing--
          }
        }

        if (!hide) {
          if (this.colorFilter.length) {
            // if this horse matches any of the selected colors, show it
            let colorMatched = false
            for (let j = 0; j < this.colorFilter.length; j++) {
              const checkColor = this.colorFilter[j].replace('--', '/')
              if (checkColor === checkHorse.color) {
                colorMatched = true
                break
              }
            }

            if (!colorMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.patternFilter.length) {
            // if this horse matches any of the selected patterns, show it
            let patternMatched = false
            for (let j = 0; j < this.patternFilter.length; j++) {
              const checkPattern = this.patternFilter[j]
              if (checkPattern === checkHorse.pattern) {
                patternMatched = true
                break
              }
            }

            if (!patternMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          let heightMatched = true
          if (this.heightFilterMin > checkHorse.height || this.heightFilterMax < checkHorse.height) {
            heightMatched = false
          }

          if (!heightMatched) {
            hide = true
            this.currentlyShowing--
          }
        }

        if (!hide) {
          let priceMatched = true
          if (this.priceFilterMin > checkHorse.price || this.priceFilterMax < checkHorse.price) {
            priceMatched = false
          }

          if (!priceMatched) {
            hide = true
            this.currentlyShowing--
          }
        }

        if (!hide) {
          if (this.registryFilter.length) {
            // if this horse matches any of the selected registrys, show it
            let registryMatched = false
            for (let j = 0; j < this.registryFilter.length; j++) {
              const checkRegistry = this.registryFilter[j]
              if (checkHorse.registries.indexOf(checkRegistry) >= 0) {
                registryMatched = true
                break
              }
            }

            if (!registryMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (this.currentlyShowing > this.maxToShow) {
          hide = true
        }

        if (!hide) {
          this.horses.push(checkHorse)
        }
      }
    },
    updateFilters: function () {
      const rootObj = this

      var displaySexOptions = []
      var displayAgeMin = 50
      var displayAgeMax = 0
      var displayColorOptions = []
      var displayPatternOptions = []
      var displayHeightMin = 40
      var displayHeightMax = 0
      var displayPriceMin = 999999
      var displayPriceMax = 0
      var displayRegistryOptions = []

      for (let i = 0; i < this.allHorses.length; i++) {
        var checkHorse = this.allHorses[i]

        if (checkHorse.age < displayAgeMin) {
          displayAgeMin = checkHorse.age
        }

        if (checkHorse.age > displayAgeMax) {
          displayAgeMax = checkHorse.age
        }

        displaySexOptions.push(checkHorse.sex)
        displayColorOptions.push(checkHorse.color)
        displayPatternOptions.push(checkHorse.pattern)

        if (checkHorse.height < displayHeightMin) {
          displayHeightMin = checkHorse.height
        }

        if (checkHorse.height > displayHeightMax) {
          displayHeightMax = checkHorse.height
        }

        if (checkHorse.price < displayPriceMin) {
          displayPriceMin = checkHorse.price
        }

        if (checkHorse.price > displayPriceMax) {
          displayPriceMax = checkHorse.price
        }

        if (Array.isArray(checkHorse.registries)) {
          checkHorse.registries.forEach(function (registry) {
            displayRegistryOptions.push(registry)
          })
        }
      }

      rootObj.ageMin = displayAgeMin
      rootObj.ageMax = displayAgeMax

      rootObj.sexOptions = []
      rootObj.allSexOptions.forEach(function (sex) {
        if (displaySexOptions.indexOf(sex) >= 0) {
          rootObj.sexOptions.push(sex)
        }
      })

      rootObj.colorOptions = []
      rootObj.allColorOptions.forEach(function (color) {
        if (displayColorOptions.indexOf(color) >= 0) {
          rootObj.colorOptions.push(color)
        }
      })

      rootObj.patternOptions = []
      rootObj.allPatternOptions.forEach(function (pattern) {
        if (displayPatternOptions.indexOf(pattern) >= 0) {
          rootObj.patternOptions.push(pattern)
        }
      })

      rootObj.heightMin = displayHeightMin
      rootObj.heightMax = displayHeightMax

      rootObj.priceMin = displayPriceMin
      rootObj.priceMax = displayPriceMax

      rootObj.registryOptions = []
      rootObj.allRegistryOptions.forEach(function (registry) {
        if (displayRegistryOptions.indexOf(registry) >= 0) {
          rootObj.registryOptions.push(registry)
        }
      })
    },
    loadMore: function () {
      this.maxToShow += this.numberPerPage
      this.filterHorses()
    }
  }
}
</script>
